const funnyMusic = (answers) => {
  return answers.map((answer) =>
    answer.toLowerCase() === "three 6 mafia" ? "Explanation Attitude" : answer
  );
};

export default funnyMusic;
